// Site-wide config pulled from env. Sensible defaults are provided so the dev
// build runs even when these aren't set; replace before going live.
export const SITE = {
  url:          import.meta.env.VITE_SITE_URL          || "https://mediaonautopilot.com",
  contactEmail: import.meta.env.VITE_CONTACT_EMAIL     || "hello@mediaonautopilot.com",
  privacyEmail: import.meta.env.VITE_PRIVACY_EMAIL     || "privacy@mediaonautopilot.com",
  legalEmail:   import.meta.env.VITE_LEGAL_EMAIL       || "legal@mediaonautopilot.com",
  legalState:   import.meta.env.VITE_LEGAL_STATE       || "[Your State]",
  legalCity:    import.meta.env.VITE_LEGAL_CITY        || "[Your City]",
};
